import { styled } from '@mui/material';

const ErrorBackdrop = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '100%',
});

const ErrorContainer = styled('div')({
  width: '100%',
  maxWidth: '360px',
  padding: '16px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '8px',
});

const ErrorImg = styled('img')({
  width: '128px',
  height: '128px',
});

const ErrorHeader = styled('h1')({
  fontSize: '24px',
  lineHeight: '140%',
  letterSpacing: '0',
  fontWeight: 400,
  textAlign: 'center',

  margin: 0,
});

const ErrorMessage = styled('p')({
  fontSize: '16px',
  lineHeight: '140%',
  letterSpacing: '0.15px',
  fontWeight: 400,
  textAlign: 'center',

  color: 'rgba(0, 0, 0, 0.4)',

  margin: 0,
});

const RetryButton = styled('button')({
  width: '100%',
  height: '48px',
  marginTop: '48px',
  padding: '0.5rem 2rem',

  backgroundColor: '#1976D2',
  color: '#fff',
  border: 'none',
  borderRadius: '8px',

  cursor: 'pointer',

  fontSize: '15px',
  fontWeight: 500,
  lineHeight: '26px',
  letterSpacing: '0.46px',
  textTransform: 'uppercase',

  '&:hover': {
    backgroundColor: '#1565c0',
  },
});

export interface PortalConfigurationErrorProps {
  title?: string;
  errorMessage: string;
  showRetry?: boolean;
}

export const PortalConfigurationError = ({
  title = 'Unable to load app',
  errorMessage,
  showRetry = true,
}: PortalConfigurationErrorProps) => {
  return (
    <ErrorBackdrop>
      <ErrorContainer>
        <ErrorImg src="/assets/page-not-found.svg" alt="Page not found" />

        <ErrorHeader>{title}</ErrorHeader>
        <ErrorMessage>{errorMessage}</ErrorMessage>

        {showRetry && (
          <RetryButton onClick={() => window.location.reload()}>
            Retry
          </RetryButton>
        )}
      </ErrorContainer>
    </ErrorBackdrop>
  );
};
